// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".first-type-select .el-radio__label{padding-left:4px;font-size:12px}", ""]);
// Exports
module.exports = exports;
